import React from 'react';
import './GalleryView.scss';

const GalleryView = ({ data, onDetail }) => (
  <div className="gallery-view-container">
    {data.map((item) => (
      <div key={item.id} className="gallery-card" onClick={() => onDetail(item)}>
        <div className="thumb">
          <img src={item.thumbnail || 'https://via.placeholder.com/400x260'} alt={item.title} />
          <div className="overlay">자세히 보기</div>
        </div>
        <div className="info">
          <h3>{item.title}</h3>
          <p className="date">{item.date}</p>
        </div>
      </div>
    ))}
  </div>
);

export default GalleryView;